import { Alert, AlertDescription } from "@/components/ui/alert";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface PaidAccessVisibilityAlertProps {
  showRestoreOption?: boolean;
  restorePublic?: boolean;
  onRestorePublicChange?: (checked: boolean) => void;
}

export function PaidAccessVisibilityAlert({
  showRestoreOption = false,
  restorePublic = true,
  onRestorePublicChange,
}: PaidAccessVisibilityAlertProps) {
  return (
    <Alert variant="default" className="space-y-3">
      <AlertDescription className="text-sm">
        With paid access turned off, this resource may not appear in the patron Paid Resources list.
        Patrons can still use public OPAC when &quot;Make this resource publicly accessible&quot; is
        enabled below.
      </AlertDescription>
      {showRestoreOption && onRestorePublicChange && (
        <div className="flex items-center gap-2">
          <Checkbox
            id="restorePublicOpac"
            checked={restorePublic}
            onCheckedChange={(c) => onRestorePublicChange(!!c)}
          />
          <Label htmlFor="restorePublicOpac" className="cursor-pointer text-sm font-normal">
            Restore public OPAC access when saving (recommended if removing paid rules)
          </Label>
        </div>
      )}
    </Alert>
  );
}
